import type { ButtonVariant } from '@tundr/theme';
import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';

export type ButtonProps = {
  id?: string;
  testId?: string;
  title?: string;
  role?: string;
  type?: ButtonTypes;
  size?: ButtonSizes;
  iconName?: TUNDR_ICONS;
  variant?: ButtonVariant;
  textAlign?: ButtonAlignmentVariant;
  width?: ButtonWidthVariant;
  disabled?: boolean;
  textEllipsis?: boolean;
  loading?: boolean;
  label?: string;
  tooltipText?: string;
  tooltipDescription?: string;
  tooltipClass?: string;
};

export enum ButtonWidthVariant {
  FULL = 'full',
  FIXED = 'fixed',
  AUTO = 'auto',
  MIN = 'min',
}

export enum ButtonAlignmentVariant {
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
}

export enum ButtonTypes {
  BUTTON = 'button',
  SUBMIT = 'submit',
  RESET = 'reset',
}

export enum ButtonSizes {
  SMALL = 'small',
  DEFAULT = 'medium',
  NO_PADDING = 'no-padding',
}
